import React, { useState } from "react";
import RackSidebar from "./RackSidebar";
import ShelfTabs from "./ShelfTabs";
import ItemGrid from "./ItemGrid";
import SearchBar from "./SearchBar";
import { FaBars } from "react-icons/fa";

const TrackInventory = ({ racks = [] }) => {
  const [selectedRack, setSelectedRack] = useState(racks[0]?.rack_name || null);
  const [selectedShelf, setSelectedShelf] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  console.log("With Batch", racks);

  if (racks?.length === 0) {
    return (
      <div className="p-6 bg-white rounded-lg shadow-md flex justify-center items-center h-full">
        <p className="text-gray-500 text-lg">
          No inventory to display. Please add racks and allocate items.
        </p>
      </div>
    );
  }

  const filterInventory = (racks) => {
    if (!searchQuery) return racks;

    return racks
      ?.map((rack) => {
        const filteredShelves = rack.shelves
          .map((shelf) => {
            const filteredBoxes = shelf.boxes
              .map((box) => {
                const filteredItems = (box.items || []).filter((item) =>
                  [item.items_name]
                    .join(" ")
                    .toLowerCase()
                    .includes(searchQuery.toLowerCase())
                );
                return { ...box, items: filteredItems };
              })
              .filter((box) => box.items.length > 0);

            return { ...shelf, boxes: filteredBoxes };
          })
          .filter((shelf) => shelf.boxes.length > 0);

        return { ...rack, shelves: filteredShelves };
      })
      .filter((rack) => rack.shelves.length > 0);
  };

  const filteredRacks = filterInventory(racks);
  const currentRack =
    filteredRacks.find((rack) => rack.rack_name === selectedRack) ||
    filteredRacks[0];
  const shelves = currentRack?.shelves || [];

  console.log(filteredRacks);

  return (
    <div className="flex flex-col h-full bg-[#f8fafc] md:flex-row">
      {/* Sidebar for Racks */}
      <div
        className={`fixed inset-y-0 left-0 z-40 w-64 text-black transform bg-white ${
          isSidebarOpen ? "translate-x-0" : "-translate-x-full"
        } transition-transform duration-300 md:static md:translate-x-0 md:flex-shrink-0`}
      >
        <RackSidebar
          racks={filteredRacks}
          selectedRack={selectedRack}
          onRackSelect={(rackName) => {
            setSelectedRack(rackName);
            setSelectedShelf(null); // Reset shelf on rack change
            setIsSidebarOpen(false); // Close sidebar on mobile
          }}
        />
      </div>

      {/* Main Content */}
      <div className="flex flex-col flex-grow p-4 md:p-6 space-y-4">
        {/* Search Bar & Mobile Sidebar Toggle */}
        <div className="flex items-center justify-between bg-white p-4 rounded-lg">
          <h1 className="text-xl md:text-2xl font-bold text-[#111827]">
            Track Inventory
          </h1>
          <SearchBar
            placeholder="Search items across all racks..."
            searchQuery={searchQuery}
            onSearch={(query) => setSearchQuery(query)}
          />
          <button
            className="p-2 bg-[#3b82f6] text-white rounded-full shadow-lg hover:bg-[#2563eb] transition md:hidden"
            onClick={() => setIsSidebarOpen(!isSidebarOpen)}
          >
            <FaBars size={20} />
          </button>
        </div>

        {/* Rack Header */}
        <div className="flex flex-col md:flex-row md:justify-between items-center">
          <div>
            <h2 className="text-lg md:text-xl font-bold text-[#111827]">
              {currentRack?.rack_name || "Select a Rack"}
            </h2>
            <p className="text-[#6b7280] text-sm">
              Category:{" "}
              <span className="font-medium text-[#111827]">
                {currentRack?.category || "N/A"}
              </span>
            </p>
          </div>
        </div>

        {/* Shelf Tabs */}
        <ShelfTabs
          shelves={shelves}
          selectedShelf={selectedShelf}
          onShelfSelect={(shelfName) => setSelectedShelf(shelfName)}
        />

        {/* Item Grid */}
        <div className="bg-white rounded-lg shadow-lg p-4 md:p-6">
          <ItemGrid
            shelves={shelves.filter(
              (shelf) => !selectedShelf || shelf.shelf_name === selectedShelf
            )}
            searchQuery={searchQuery}
          />
        </div>
      </div>
    </div>
  );
};

export default TrackInventory;
